<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div v-show="form.type === null">
            <div>
                {{ $t('messages.activity_type') }}
            </div>

            <div class="flex flex-wrap space-x-2 justify-start items-center">
                <AppButton
                    @click="form.type = type.value"
                    type="button"
                    v-for="type in options.types"
                    :key="type.value"
                    element="button"
                >
                    {{ type.text }}
                </AppButton>
            </div>
        </div>

        <form :action="meta.links.store" method="post" @submit.prevent="submit" v-show="form.type !== null">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.trimester')" for="trimester" />
                            <FormSelect
                                required
                                id="trimester"
                                v-model="form.trimester"
                                :options="options.trimesters"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.trimester" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.subject', 1)" for="subject_id" />
                            <FormSelect
                                required
                                id="subject_id"
                                v-model="form.subject_id"
                                :options="options.subjects"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.trimester" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.files', 1)" for="file" />
                            <input
                                id="file"
                                @input="form.file = $event.target.files[0]"
                                name="file"
                                type="file"
                                accept=".csv"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.file" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <FormLabel :value="$t('messages.grade_level')" for="grade_level_ids" />
                        <div class="mt-1">
                            <label v-for="grade_level in options.grade_levels" class="mr-1" :key="grade_level.value">
                                <input
                                    v-model="form.grade_level_ids"
                                    name="stages"
                                    :value="grade_level.value"
                                    type="checkbox"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                />
                                {{ grade_level.text }}
                            </label>
                        </div>
                        <FormError :value="form.errors.grade_level_ids" class="mt-2" />
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5 space-x-2">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import AppButton from '@/components/AppButton.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormLabel,
        FormError,
        FormSelect,
        AppButton,
    },
    layout: Layout,
    name: 'Create',
    props: ['teacher', 'meta', 'options', 'activity', 'defaults'],
    data() {
        return {
            form: this.$inertia.form({
                subject_id: null,
                trimester: this.defaults.trimester,
                grade_level_ids: this.defaults.preferences.grade_level_id,
                file: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
